import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { apiFetch } from "../api/client";
import { COLORS, RADIUS } from "../theme";
import Card from "../components/ui/Card";
import Btn from "../components/ui/Btn";
import Input from "../components/ui/Input";
import EstadoCarregando from "../components/ui/EstadoCarregando";

export default function Parametros() {
  const { token } = useAuth();
  const [loading, setLoading] = useState(true);
  const [toleranciaAtraso, setToleranciaAtraso] = useState("5");
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState(false);

  useEffect(() => {
    apiFetch("GET", "/api/configuracoes", undefined, token)
      .then((data) => setToleranciaAtraso(String(data.tolerancia_atraso_min)))
      .finally(() => setLoading(false));
  }, [token]);

  const salvar = async () => {
    setErro("");
    setSucesso(false);
    setSalvando(true);
    try {
      await apiFetch("PUT", "/api/configuracoes", { tolerancia_atraso_min: Number(toleranciaAtraso) }, token);
      setSucesso(true);
    } catch (e) {
      setErro(e.message);
    } finally {
      setSalvando(false);
    }
  };

  if (loading) return <EstadoCarregando />;

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 24, fontWeight: 800, color: COLORS.text, margin: "0 0 4px", letterSpacing: "-0.02em" }}>
          Parâmetros
        </h1>
        <p style={{ fontSize: 13.5, color: COLORS.textMid, margin: 0 }}>
          Métricas operacionais do ponto, ajustáveis conforme a política da empresa.
        </p>
      </div>

      <Card style={{ maxWidth: 480 }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div>
            <Input
              label="Tolerância de atraso (minutos)"
              type="number"
              min={1}
              max={120}
              value={toleranciaAtraso}
              onChange={(e) => setToleranciaAtraso(e.target.value)}
            />
            <p style={{ fontSize: 11.5, color: COLORS.textLight, margin: "6px 0 0" }}>
              A partir de quantos minutos de diferença uma entrada conta como atraso, na tela "Atrasos e Faltas" e no
              Fechamento Mensal. Não afeta o fechamento automático de turno (30 min, fixo).
            </p>
          </div>

          {erro && (
            <div style={{ color: COLORS.danger, fontSize: 13, background: COLORS.dangerBg, border: "1px solid #FECACA", borderRadius: RADIUS.sm, padding: "9px 13px" }}>
              {erro}
            </div>
          )}
          {sucesso && (
            <div style={{ color: COLORS.success, fontSize: 13, background: COLORS.successBg, border: "1px solid #BBF7D0", borderRadius: RADIUS.sm, padding: "9px 13px" }}>
              Parâmetros salvos.
            </div>
          )}

          <Btn onClick={salvar} disabled={salvando} style={{ alignSelf: "flex-start" }}>
            {salvando ? "Salvando..." : "Salvar"}
          </Btn>
        </div>
      </Card>
    </div>
  );
}
